/**
 * by wit on 2024-03-06
 * 路由拦截，通常也是登录拦截
 * 可以设置路由白名单，或者黑名单，看业务需要选哪一个
 * 我这里应为大部分都可以随便进入，所以使用黑名单
 */
import { useUserStore } from '/@/store/modules/user'
import { getNoNeedLoginPages } from '/@/utils'

// TODO Check
const loginRoute = '/pages/login/index'
// 白名单登录拦截器 - （适用于少部分页面不需要登录，大部分页面需要登录）
const navigateToInterceptor = {
  // 注意，这里的url是 '/' 开头的，如 '/pages/index/index'，跟 'pages.json' 里面的 path 不同
  invoke: ({ url }: { url: string }) => {
    // console.log(url) // /pages/route-interceptor/index?name=feige&age=30
    const path = url.split('?')[0]
    let noNeedLoginPages: string[] = []
    // 获取所有不要登录权限的页面
    noNeedLoginPages = getNoNeedLoginPages()
    const isNoNeedLogin = noNeedLoginPages.includes(path)
    if (isNoNeedLogin) {
      return true
    }
    const { token } = useUserStore()
    if (token) {
      return true
    }
    const redirectRoute = `${loginRoute}?redirect=${encodeURIComponent(url)}`
    uni.navigateTo({ url: redirectRoute })
    return false
  },
}

export const routeInterceptor = {
  install() {
    uni.addInterceptor('navigateTo', navigateToInterceptor)
    uni.addInterceptor('reLaunch', navigateToInterceptor)
    uni.addInterceptor('redirectTo', navigateToInterceptor)
    uni.addInterceptor('switchTab', navigateToInterceptor)
  },
}
